import * as React from 'react';
import ClusterComponent from './ClusterComponent';
import SummaryComponent from './SummaryComponent';
import {
    Grid
} from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';

export default class PageComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            mnpTableData: {},
            grandTotalSupplySetOne: 0,
            grandTotalSupplySetTwo: 0
        };

        this.updateQuestion = this.updateQuestion.bind(this);
        this.updateQuestionVisibility = this.updateQuestionVisibility.bind(this);
        this.goToQuestion = this.goToQuestion.bind(this);
        this.addQuestionComment = this.addQuestionComment.bind(this);
        this.loaderVisibility = this.loaderVisibility.bind(this);
        
    }

    loaderVisibility(data: any) {
        this.props.loaderVisibility(data);
    }

    addQuestionComment(updateQuestionCommentData: any) {
        this.props.addQuestionComment(updateQuestionCommentData);
    }

    updateQuestion(updateQuestionData: any, isVisibleDepend?: boolean) {
        this.props.updateQuestion(updateQuestionData, isVisibleDepend);
    }

    updateQuestionVisibility(updateQuestionVisibilityData: any) {
        this.props.updateQuestionVisibility(updateQuestionVisibilityData)
    }

    goToQuestion(data: any) {
        this.props.goToQuestion(data);
    }

   

    getQuestion(pageNumber: any, clusterIndex: any, questionIndex: any) {
        if (this.props.pages && this.props.pages.length > 0) {
            const pages = this.props.pages;
            const page: any = pages[pageNumber - 1];
            const clusters = page.page.question_clusters;
            const cluster = clusters[clusterIndex];
            const question = cluster.questions[questionIndex];

            return question;
        }
        else {
            return null;
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (this.props.pagePreview.page_number !== nextProps.pagePreview.page_number) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }

        if (nextProps.pagePreview.page_number && nextProps.moduleId && nextProps.pagePreview.page_number === 2 && nextProps.moduleId === 19) {
            const questionOne = this.getQuestion(nextProps.pagePreview.page_number - 1, 0, 0);
            const questionTwo = this.getQuestion(nextProps.pagePreview.page_number - 1, 0, 1);
            if (questionOne && questionTwo && questionOne.question_responses && questionTwo.question_responses && questionOne.question_responses.length > 0 && questionTwo.question_responses.length > 0) {
                const questionOneResponse = parseInt(questionOne.question_responses[0].value, 10);
                const questionTwoResponse = parseInt(questionTwo.question_responses[0].value, 10);
                const columnTwoData = isNaN(questionTwoResponse) ? 0 : questionTwoResponse * 2;
                const columnThreeData = questionOneResponse ? questionOneResponse * columnTwoData : 0;
                const columnFourData = parseInt(((5 / 100) * columnThreeData).toString(), 10);
                const columnFiveData = parseInt(((columnThreeData + columnFourData) / 30).toString(), 10);

                const mnpTableData = {
                    columnTwo: columnTwoData,
                    columnThree: columnThreeData,
                    columnFour: columnFourData,
                    columnFive: columnFiveData
                };

                this.setState({ mnpTableData });
            }
        }

        this.calculateVasForecastCalculation(nextProps);
    }

    getSetOneResponse(pageNumber: any, clusterInex: any, questionIndex: any) {
        const question = this.getQuestion(pageNumber, clusterInex, questionIndex);
        const responses = question.question_responses;
        return responses[0].value;
    }

    getSetTwoResponse(pageNumber: any, clusterInex: any, questionIndex: any) {
        const question = this.getQuestion(pageNumber, clusterInex, questionIndex);
        const responses = question.question_responses;
        return responses[1].value;
    }

    calculateVasForecastCalculation(nextProps: any) {
        if (nextProps.pagePreview.page_number && nextProps.moduleId && nextProps.moduleId === 20) {
            const page4Question10Set1Response = this.getSetOneResponse(4, 0, 9);
            const page4Question10Set2Response = this.getSetTwoResponse(4, 0, 9);
            const page3Question6Set1Response = this.getSetOneResponse(3, 0, 6);
            const page3Question6Set2Response = this.getSetTwoResponse(3, 0, 6);
            const subtotalSemester1SetOne = (!isNaN(parseFloat(page4Question10Set1Response)) ? parseFloat(page4Question10Set1Response) : 0) + (!isNaN(parseFloat(page3Question6Set1Response)) ? parseFloat(page3Question6Set1Response) : 0);
            const subtotalSemester1SetTwo = (!isNaN(parseFloat(page4Question10Set2Response)) ? parseFloat(page4Question10Set2Response) : 0) + (!isNaN(parseFloat(page3Question6Set2Response)) ? parseFloat(page3Question6Set2Response) : 0);
            console.log('subtotalSemester1SetTwo', subtotalSemester1SetOne, subtotalSemester1SetTwo);

            const page6Question9Set1Response = this.getSetOneResponse(6, 0, 9);
            const page6Question9Set2Response = this.getSetTwoResponse(6, 0, 9);
            const page5Question6Set1Response = this.getSetOneResponse(5, 0, 6);
            const page5Question6Set2Response = this.getSetTwoResponse(5, 0, 6);
            const subtotalSemester2SetOne = (!isNaN(parseFloat(page6Question9Set1Response)) ? parseFloat(page6Question9Set1Response) : 0) + (!isNaN(parseFloat(page5Question6Set1Response)) ? parseFloat(page5Question6Set1Response) : 0);
            const subtotalSemester2SetTwo = (!isNaN(parseFloat(page6Question9Set2Response)) ? parseFloat(page6Question9Set2Response) : 0) + (!isNaN(parseFloat(page5Question6Set2Response)) ? parseFloat(page5Question6Set2Response) : 0);
            console.log('subtotalSemester2SetTwo', subtotalSemester2SetOne, subtotalSemester2SetTwo);

            const page7Question2Set1Response = this.getSetOneResponse(7, 0, 1);
            const page7Question2Set2Response = this.getSetTwoResponse(7, 0, 1);
            const page7Question24Set1Response = this.getSetOneResponse(7, 1, 3);
            const page7Question24Set2Response = this.getSetTwoResponse(7, 1, 3);
            const VacForTratmentSetOne = (!isNaN(parseFloat(page7Question2Set1Response)) ? parseFloat(page7Question2Set1Response) : 0) + (!isNaN(parseFloat(page7Question24Set1Response)) ? parseFloat(page7Question24Set1Response) : 0);
            const VacForTratmentSetTwo = (!isNaN(parseFloat(page7Question2Set2Response)) ? parseFloat(page7Question2Set2Response) : 0) + (!isNaN(parseFloat(page7Question24Set2Response)) ? parseFloat(page7Question24Set2Response) : 0);

            const page8QuestionSet1Response = this.getSetOneResponse(8, 0, 0);
            const page8QuestionSet2Response = this.getSetTwoResponse(8, 0, 0);
            const handlingLossesSetOne = ((subtotalSemester1SetOne + subtotalSemester2SetOne + VacForTratmentSetOne) * (!isNaN(parseFloat(page8QuestionSet1Response)) ? parseFloat(page8QuestionSet1Response) : 0)) / 100;
            const handlingLossesSetTwo = ((subtotalSemester1SetTwo + subtotalSemester2SetTwo + VacForTratmentSetTwo) * (!isNaN(parseFloat(page8QuestionSet2Response)) ? parseFloat(page8QuestionSet2Response) : 0)) / 100;

            const page9QuestionSet1Response = this.getSetOneResponse(9, 3, 0);
            const page9QuestionSet2Response = this.getSetTwoResponse(9, 3, 0);

            const grandTotalSupplySetOne = ((subtotalSemester1SetOne + subtotalSemester2SetOne + VacForTratmentSetOne + handlingLossesSetOne) - (!isNaN(parseFloat(page9QuestionSet1Response)) ? parseFloat(page9QuestionSet1Response) : 0)).toFixed(0);
            const grandTotalSupplySetTwo = ((subtotalSemester1SetTwo + subtotalSemester2SetTwo + VacForTratmentSetTwo + handlingLossesSetTwo) - (!isNaN(parseFloat(page9QuestionSet2Response)) ? parseFloat(page9QuestionSet2Response) : 0)).toFixed(0);

            this.setState({ grandTotalSupplySetOne, grandTotalSupplySetTwo });
        }
    }

    render() { 
        return (
            <>
            
                {                 
                    this.props.pagePreview && this.props.pagePreview.title && this.props.clusters &&
                    <div className="pagePreviewWrapper">
                        <div className="pagePreviewTopSection">
                            <Grid container={true} spacing={24}>
                                <Grid item={true} xs={12}>
                                    <div className="pagePreviewTitle"><h3>{this.props.pagePreview.title.en}</h3></div>
                                    <div>
                                        <p>
                                            {ReactHtmlParser(this.props.pagePreview.page_description.en)}
                                        </p>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="pagePreviewQueSection">
                            {
                                this.props.clusters.map((cluster: any, key: any) => {
                                    return (
                                        <>
                                            <ClusterComponent
                                                pages={this.props.pages}
                                                pageNumber={this.props.pagePreview.page_number}
                                                pagePreview={this.props.pagePreview}
                                                updateQuestionVisibility={this.updateQuestionVisibility}
                                                updateQuestion={this.updateQuestion}
                                                addQuestionComment={this.addQuestionComment}
                                                clusterIndex={key}
                                                key={'cluster-component' + key}
                                                cluster={cluster}
                                                countryModuleSurveyMappingId={this.props.countryModuleSurveyMappingId}
                                                moduleId={this.props.moduleId}
                                                surveyStatus={this.props.surveyStatus}
                                                surveyType={this.props.surveyType}                                                                                 
                                                isResponsePage={this.props.isResponsePage}
                                                loaderVisibility={this.loaderVisibility}
                                                isOfflineMode={this.props.isOfflineMode}
                                                isShowRecentData={this.props.isShowRecentData}
                                            />
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                }
                {
                    this.props.pagePreview.issummary === true
                        ?
                        <SummaryComponent
                            pagePreview={this.props.pagePreview}
                            surveyStatus={this.props.surveyStatus}
                            countryModuleSurveyMappingId={this.props.countryModuleSurveyMappingId}
                            pages={this.props.pages}
                            goToQuestion={this.goToQuestion}
                            moduleId={this.props.moduleId}
                            isOfflineMode={this.props.isOfflineMode}
                            moduleName={this.props.moduleName}
                            surveyId={this.props.surveyId}
                        />
                        : ''

                }
                {
                    this.props.pagePreview.issummary && this.props.moduleId && this.props.moduleId === 20
                        ?
                        <div className="pagePreviewWrapper">
                            <div className="pagePreviewQueSection">
                                <div className="cluster1">
                                    <table className="summaryTable" style={{ width: '100%', textAlign: 'left', marginBottom: '-3px' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '60%' }} />
                                                <th style={{ width: '40%' }} />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>GRAND TOTAL SUPPLY NEEDS FOR 2022</td>
                                                <td>
                                                    <p style={{ paddingTop: '0' }}>
                                                        <span style={{ display: 'inline-block' }}>100,000 IU (Blue) capsules S7800003 </span>
                                                        <span style={{ margin: '0px 10px' }}> <b>{this.state.grandTotalSupplySetOne}</b> </span>
                                                    </p>
                                                    <p style={{ paddingTop: '0' }}>
                                                        <span style={{ display: 'inline-block' }}>200,000 IU (Red) capsules S7800002 </span>
                                                        <span style={{ margin: '0px 10px' }}> <b>{this.state.grandTotalSupplySetTwo}</b> </span>
                                                    </p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        :
                        ''
                }
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/responses/PageComponent.tsx